import { Room as RoomType } from "twilio-video";
import styled from "styled-components";
import ChatButtons from "./ChatButtons/ChatButtons";
import ChangeCameraButton from "../Buttons/ChangeCameraButton";
import ActionButtons from "./ActionButtons/ActionButtons";

const ActionRowWrapper = styled("div")`
  width: 100%;
  height: 60px;
  display: flex;
  padding: 8px 0;
  box-sizing: border-box;
  justify-content: space-between;
  margin: 6px 0;

  background: rgba(28, 28, 28, 0.5);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(1.8px);
  -webkit-backdrop-filter: blur(1.8px);
  border: 1px solid rgba(63, 63, 63, 0.752);
  border-left: none;
  border-right: none;
`;

interface IButtonRowProps {
  room: RoomType;
  onToggleWaitingList: () => void;
}

const ActionRow = ({ room, onToggleWaitingList }: IButtonRowProps) => {
  const buttonSpacing = 6;

  return (
    <ActionRowWrapper>
      <ChangeCameraButton room={room} />
      <ActionButtons buttonsSpacing={buttonSpacing} />
      <ChatButtons buttonsSpacing={buttonSpacing} onToggleWaitingList={onToggleWaitingList} />
    </ActionRowWrapper>
  );
};

export default ActionRow;
